/* global G */
import { PlatformEvent } from 'lib/util'
import sequenceComponentFindProxy from 'lib/sequence/component/children/find'

const descriptor = Symbol('hook::module::search').toString()

/**
 * Search Hook
 *
 * Configures the {@link SearchField}, which should be available in the AppBar component, by
 * attaching the onSearch event handler as a new property of the action.ui.search object.
 *
 * @param {Gaia.AppModule.Spec} obj  the current module composition object
 * @returns {function(...[*]): Promise<*[]>}
 */
const search = obj => async (...args) => {
  try {
    const userContext = obj[G.ADAPTER][G.SESSION][G.STATE][G.CONTEXT]
    const action = obj[G.STATE][G.ACTION]
    const actionUi = obj[G.STATE][G.ACTION][G.UI]
    const givenContexts = actionUi.search?.contexts
    const cache = action[G.CACHE].search?._cache
    const { term, transform } = cache || {}
    const value = term || null

    if (givenContexts && !givenContexts.includes(userContext)) {
      delete actionUi.search
    } else {
      const handlerName = actionUi?.search?.events?.onClick || null
      const searchEvents = obj[G.EVENTS].onSearch
      // Using specified or first event handler
      const onSearch = searchEvents[handlerName || Object.keys(searchEvents)[0]]

      const actionComponent = obj[G.STATE][G.ACTION][G.COMPONENT]
      const { [actionUi?.search?.component]: targetComponent } = sequenceComponentFindProxy(actionComponent)

      const onSearchPartial = onSearch(obj, targetComponent || actionComponent)
      actionUi.search = { ...actionUi.search, onSearch: onSearchPartial, value, transform }
      // if the action's search has data cached (e.g. through the remember event handler), we need
      // to trigger a search event with it, so that the application updates its content accordingly
      cache && onSearchPartial(new PlatformEvent('search', { term: value, transform, reload: false }))
    }
  } catch (e) {
    throw Error(`${obj._name} ${descriptor} - ${e.message}`)
  }
  return args
}

export default search
